import { Box, CircularProgress, Skeleton, Typography } from "@mui/material";
import React from "react";
import { useResponsiveHeight } from "../../hooks";

interface LoadingScreenProps {
  message?: string;
  showSkeleton?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Carregando...",
  showSkeleton = false,
}) => {
  const { getHeightStyles } = useResponsiveHeight();

  if (showSkeleton) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f0f2f5",
          gap: 3,
          ...getHeightStyles(),
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Skeleton variant="circular" width={80} height={80} />
          <Skeleton variant="text" width={200} height={24} />
          <Skeleton variant="text" width={150} height={16} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            width: "300px",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height={40} />
          <Skeleton variant="rectangular" width="100%" height={40} />
          <Skeleton variant="rectangular" width="60%" height={40} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f2f5",
        gap: 2,
        ...getHeightStyles(),
      }}
    >
      <CircularProgress size={60} sx={{ color: "#008069" }} />
      <Typography variant="h6" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
